import { render, staticRenderFns } from "./DocumentCopyDialog.vue?vue&type=template&id=f917a8cc"
import script from "./DocumentCopyDialog.vue?vue&type=script&lang=js"
export * from "./DocumentCopyDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentCopyDialog.vue?vue&type=style&index=0&id=f917a8cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports